<template>
    <div class="pages">
        <pdf src="http://192.168.70.152/group1/M00/00/37/wKhGmGKPTIuAMfVMAAASGfEB5fk341.pdf"></pdf>
    </div>
</template>

<script>
import pdf from 'vue-pdf'
export default {
    components: { pdf },
    data() {
        return {
            wordUrl: 'http://192.168.70.152/group1/M00/00/37/wKhGmGKPTIuAMfVMAAASGfEB5fk341.pdf'
        }
    },
}
</script>

<style>
.pages {
    font-size: 16px;
}
</style>